import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldLabel, FormField } from '../styled';
import { SourceMode } from '../utils';

interface SourceModeToggleProps {
  value: SourceMode;
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    newMode: SourceMode | null,
  ) => void;
}

const SourceModeToggle = ({ value, onChange }: SourceModeToggleProps) => {
  const { t } = useTranslation('common');

  return (
    <FormField>
      <FieldLabel>{t('assistant.ragStorageDialog.source')}</FieldLabel>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={onChange}
        sx={{ width: '100%' }}
      >
        <ToggleButton value="text" sx={{ flex: 1 }}>
          {t('assistant.ragStorageDialog.pasteText')}
        </ToggleButton>
        <ToggleButton value="document" sx={{ flex: 1 }}>
          {t('assistant.ragStorageDialog.uploadDocument')}
        </ToggleButton>
      </ToggleButtonGroup>
    </FormField>
  );
};

export default SourceModeToggle;
